import { InteractionUpdateInput } from '@api/generated/graphql';
import { getClient } from '@api/client';
import { UPDATE_INTERACTION_BY_CHANNEL_ID_MUTATION } from '@modules/InteractionsModule/lib/mutations';

export const updateInteractionByChannelIdV2 = async (
  channelId: string,
  tenantId: string | undefined,
  input: InteractionUpdateInput,
) => {
  const { data } = await getClient().mutate({
    mutation: UPDATE_INTERACTION_BY_CHANNEL_ID_MUTATION,
    variables: { channelId, tenantId, input },
  });

  if (!data?.updateInteractionByChannelId) {
    throw new Error('No data');
  }

  return data?.updateInteractionByChannelId;
};
